//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  name: '',
  components: {
    ElImageViewer: ElImageViewer
  },
  props: ['tableData', 'edit', 'ids'],
  data: function data() {
    return {
      table: [],
      isImage: false,
      srcList: [],
      multipleSelection: [],
      total: 0
    };
  },
  watch: {
    tableData: {
      handler: function handler(nVal) {
        this.table = nVal;
      }
    },
    ids: {
      handler: function handler(nVal) {
        this.multipleSelection = nVal;
      }
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.$emit('handleSelectionFn', val);
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    handlePictureCardPreview: function handlePictureCardPreview(val) {
      this.srcList.push(val);
      this.isImage = true;
    },
    deleteFn: function deleteFn(row) {
      var _this = this;
      this.$modalSure('确认移除此付款订单吗').then(function () {
        _this.table = _this.table.filter(function (item) {
          return item.id != row.id;
        });
        _this.$emit('totalFn', _this.total, _this.table);
      });
    }
  }
};